<template>
  <v-layout>
    <v-flex xs12 class="text-xs-center tabs-container">
      <v-card
        :raised="!value"
        :flat="value != null"
        v-if="!$apollo.loading && purchaseInvoicePayment"
      >
        <v-card-title class="grey lighten-3" v-if="!value">
          <v-row>
            <v-col class="py-0">{{ purchaseInvoicePayment.piNumber }}</v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pt-3 pb-0">
          <purchase-invoice-payment-details-editor
            :purchaseInvoicePayment="purchaseInvoicePayment"
            @onChange="payment = $event"
          ></purchase-invoice-payment-details-editor>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center pb-3 v-if="!value">
            <v-btn color="primary" @click="savePayment">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
      <back-to-list-btn
        v-if="false"
        route="/purchase-invoice-payments"
      ></back-to-list-btn>
      <div v-if="debug">{{ payment }}</div>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  PURCHASE_INVOICE_PAYMENT_RECORD_QUERY,
  PURCHASE_INVOICE_PAYMENT_UPDATE_MUTATION,
} from "../../../../constants/graphql";
import PurchaseInvoicePaymentDetailsEditor from "./PurchaseInvoicePaymentDetailsEditor";
import BackToListBtn from "../../shared/BackToListBtn";

export default {
  name: "PurchaseInvoicePaymentDetails",

  props: {
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    PurchaseInvoicePaymentDetailsEditor,
    BackToListBtn,
  },

  data() {
    return {
      debug: false,
      id: this.value ? this.value.id : this.$route.params.id,
      payment: {},
    };
  },

  watch: {
    value(newVal) {
      this.id = newVal.id;
    },
  },

  methods: {
    savePayment() {
      console.log("payment", this.payment);
      this.$apollo
        .mutate({
          mutation: PURCHASE_INVOICE_PAYMENT_UPDATE_MUTATION,
          variables: {
            ...this.payment,
          },
        })
        .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
    },
    saveGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", {
        msg: "Purchase Invoice Payment Updated",
      });
    },
    saveGqlObjectErrorHandler(err) {
      const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
      this.$store.dispatch("showAppSnackbar", {
        msg: errorMsg,
        color: "error",
      });
    },
    backToList() {
      this.$router.go(-1);
    },
  },

  apollo: {
    purchaseInvoicePayment: {
      query: PURCHASE_INVOICE_PAYMENT_RECORD_QUERY,
      variables() {
        return {
          id: this.id,
        };
      },
      result({ data }) {
        this.payment = { ...data.purchaseInvoicePayment };
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/finances/purchase-invoice-payments/PurchaseInvoicePaymentDetails.vue